function isFunction(type) {
    return /function Function/.test(String(type));
}
function isBoolean(type) {
    return /function Boolean/.test(String(type));
}
function isNumber(type) {
    return /function Number/.test(String(type));
}
function isObject(type) {
    return /function Object/.test(String(type));
}
function pickPropsNameByType(props, typeSelector) {
    return Object.entries(props).filter(([_, def]) => typeSelector(def.type)).map(([name]) => name);
}
function hyphenate(str) {
    return str.replace(/\B([A-Z])/g, '-$1').toLowerCase();
}
function camelize(str) {
    return str.replace(/-(\w)/g, (_, c) => c ? c.toUpperCase() : '');
}
function normalizeSchema(schema) {
    const props = Object.entries(schema.props || {}).reduce((p, [key, value]) => ({ ...p, [camelize(key)]: value }), {});
    return {
        ...schema,
        shadowRoot: "shadowRoot" in schema ? schema.shadowRoot : true,
        props,
    };
}
function parseValue(value, type) {
    if (value === null) {
        return value;
    }
    if (isBoolean(type)) {
        if (value === 'true' || value === 'false') {
            return value === 'true';
        }
        if (value === '' || value != null) {
            return true;
        }
        return value;
    }
    else if (isNumber(type)) {
        const parsed = parseFloat(value);
        return isNaN(parsed) ? value : parsed;
    }
    else if (isObject(type)) {
        try {
            return JSON.parse(value);
        }
        catch {
            return value;
        }
    }
    else {
        return value;
    }
}
export function lazyWebComponent(factoryLoader, schema) {
    let factory$;
    schema = normalizeSchema(schema);
    const propsList = pickPropsNameByType(schema.props, (type) => !isFunction(type));
    class WebComponentProxy extends HTMLElement {
        constructor() {
            super();
            this._pProps = {};
            if (schema.shadowRoot) {
                this.attachShadow({ mode: 'open' });
            }
            if (!factory$) {
                factory$ = factoryLoader();
            }
            this._pReady = factory$.then((componentMaker) => {
                this._pComponent = componentMaker(this);
                if (Object.keys(this._pProps).length > 0)
                    this._pComponent.set(this._pProps);
                if (this.isConnected)
                    this.connectedCallback();
            });
        }
        connectedCallback() {
            this._pComponent && this._pComponent.mount();
        }
        disconnectedCallback() {
            this._pComponent && this._pComponent.unmount();
        }
        adoptedCallback() {
            this._pComponent && this._pComponent.adopted();
        }
        attributeChangedCallback(attrName, _, newValue) {
            const prop = camelize(attrName);
            const def = schema.props[prop];
            this[prop] = parseValue(newValue, def.type);
        }
    }
    function createDescriptor(prop, def) {
        return isFunction(def.type)
            ? {
                value(...args) {
                    return this._pReady.then(() => this._pComponent.call(prop, args));
                }
            }
            : {
                get() {
                    if (this._pComponent)
                        return this._pComponent.get(prop);
                    return this._pProps[prop];
                },
                set(value) {
                    if (this._pComponent)
                        this._pComponent.set({ [prop]: value });
                    else
                        this._pProps[prop] = value;
                },
            };
    }
    // expose web component schema
    for (let prop in schema.props) {
        const def = schema.props[prop];
        Object.defineProperty(WebComponentProxy.prototype, prop, {
            ...createDescriptor(prop, def),
            enumerable: false,
            configurable: true
        });
    }
    // watched attributes
    WebComponentProxy.observedAttributes = propsList.map(hyphenate);
    return WebComponentProxy;
}
